import React, { useState } from "react"
import * as S from "./elements"
import { ChevronRight, ChevronLeft } from "../Icons"

interface Props {
  images: string[]
  thumbnails: string[]
}

export type navigateTo = "next" | "previous"

export const Gallery: React.FC<Props> = ({ images, thumbnails }) => {
  const [activeImg, setActiveImg] = useState(0)
  const imgLength = images.length - 1

  const handleNext = () => {
    if (activeImg < imgLength) {
      setActiveImg(activeImg + 1)
    } else {
      setActiveImg(0)
    }
  }

  const handlePrev = () => {
    if (activeImg > 0) {
      setActiveImg(activeImg - 1)
    } else {
      setActiveImg(imgLength)
    }
  }

  return (
    <S.GalleryWrapper isSingle={imgLength === 0}>
      {imgLength > 0 && (
        <S.ThumbnailWrapper>
          {thumbnails.map((src, key) => {
            return (
              <S.Thumbnail
                key={key}
                active={key === activeImg}
                onClick={() => setActiveImg(key)}
                img={src}
              />
            )
          })}
        </S.ThumbnailWrapper>
      )}
      <S.ImageContainer>
        {images.map((src, index) => (
          <S.Image
            alt="Interchangeable jewelry"
            key={index}
            src={src}
            active={index === activeImg}
          ></S.Image>
        ))}
      </S.ImageContainer>

      {imgLength > 0 && (
        <S.NavContainer>
          <S.NavButton onClick={() => handlePrev()}>
            <ChevronLeft />
          </S.NavButton>
          <S.NavButton onClick={() => handleNext()}>
            <ChevronRight />
          </S.NavButton>
        </S.NavContainer>
      )}
    </S.GalleryWrapper>
  )
}
